import { useState, useEffect } from 'react'
import throttle from 'lodash/throttle'
import { DYNAMIC_CLIENT_WIDTH } from '@/modules/globals/constants/dynamicStyle'

export default ({ dynamicSize = false }) => {
    const defaultClientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    const [size, setSize] = useState(() => {
        if (!dynamicSize) {
            return 'default'
        }
        return defaultClientWidth <= DYNAMIC_CLIENT_WIDTH ? 'small' : 'default'
    })

    useEffect(() => {
        const handler = throttle(() => {
            if (!dynamicSize) {
                return
            }
            const clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
            if (clientWidth <= DYNAMIC_CLIENT_WIDTH) {
                setSize('small')
            } else {
                setSize('default')
            }
        }, 800)
        window.addEventListener('resize', handler, false)
        return () => {
            window.removeEventListener('resize', handler, false)
        }
    }, [dynamicSize])

    return {
        size
    }
}
